var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClose.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c(
          "button",
          {
            staticClass: "close-icon",
            attrs: { "aria-label": _vm.$t("common.close") },
            on: { click: _vm.onClose },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _c("div", { staticClass: "dialog-body" }, [
          _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _c("p", { staticClass: "description" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("myPage.emailNotification.completedDialog.description")
                ) +
                " "
            ),
          ]),
        ]),
        _c("footer", [
          _c(
            "button",
            { staticClass: "button close", on: { click: _vm.onClose } },
            [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }